// import React from 'react';
// import ReactApexChart from 'react-apexcharts';

// const ColumnChart = () => {
//   const chartData = {
//     options: {
//       chart: {
//         type: 'bar',
//         toolbar: {
//           show: false,
//         },
//       },
//       plotOptions: {
//         bar: {
//           columnWidth: '50%', // Adjust the bar width as needed
//           endingShape: 'rounded', // Add rounded edges to the bars
//         },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       xaxis: {
//         categories: ['Category 1', 'Category 2', 'Category 3', 'Category 4'],
//       },
//       colors: ['#FF5733', '#FFC300', '#FF5733', '#FFC300'], // Custom bar colors
//     },
//     series: [
//       {
//         name: 'Series 1',
//         data: [45, 67, 23, 56],
//       },
//     ],
//   };

//   return (
//     <div className="bar-chart">
//       <ReactApexChart
//         options={chartData.options}
//         series={chartData.series}
//         type="bar"
//         height="350"
//       />
//     </div>
//   );
// };

// export default ColumnChart;


import React from 'react';
import ReactApexChart from 'react-apexcharts';

const ColumnChart = ({data, data2}) => {
  const arr1 = [];
  data?.map(item => {
    arr1?.push(item?.total_amount);
  })
  
  const arr2 = [];
  data2?.map(item => {
    arr2?.push(item?.total_amount);
  })

  const chartData = {
    options: {
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          columnWidth: '50%', // Adjust the bar width as needed
          borderRadiusApplication: 'end', 
          borderRadius: 4,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      },
      colors: ['#1ec06f', '#E8505B'], // Custom bar colors
    },
    series: [
      {
        name: 'Top Up',
        data: arr2,
      },
      {
        name: 'Charge',
        data: arr1,
      },
    ],
  };

  return (
    <div className="bar-chart">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height="350"
      />
    </div>
  );
};

export default ColumnChart;
